import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getRouteMetaInfo } from '@/router/routeMeta';
import styles from './index.module.scss';

const WIDE_PAGE_PATHS = [
  '/page/list',
  '/cart/carts',
  '/cart/batchAdd',
  '/cart/palletFill',
  '/order/goOrderInfo',
  '/order/detail',
  '/searchAi',
  '/rede/searchAi',
];

// 与 NavBar 一致：失效页沿用商详内容区宽度，避免比正常商详窄一档。
const isWidePagePath = (pathname: string) =>
  WIDE_PAGE_PATHS.includes(pathname) || pathname.startsWith('/sku/') || pathname === '/skuUnavailable';

const Container: React.FC = ({ children }) => {
  const location = useLocation();
  const [isFullPage, setIsFullPage] = useState(false);
  const [isWidePage, setIsWidePage] = useState(false);
  const routeMeta = getRouteMetaInfo(location.pathname);
  const shouldKeepMinHeight = routeMeta?.containerMinHeight !== false;

  // 监听路由变化，打印路由信息
  useEffect(() => {
    // 活动页复用首页楼层，由楼层统一控制宽度和边距，避免外层再次收窄。
    setIsFullPage(location.pathname === '/' || location.pathname === '/activityPage');
    setIsWidePage(isWidePagePath(location.pathname));
  }, [location]);
  return (
    <div
      className={`${styles.container} ${isFullPage ? styles.fullPageContainer : ''} ${
        isWidePage ? styles.widePageContainer : ''
      }`}
    >
      <div className={`${styles.containerBox} ${shouldKeepMinHeight ? '' : styles.containerBoxNoMinHeight}`}>
        {children}
      </div>
    </div>
  );
};

export default Container;
